var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#E84142"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6441 16.4157C22.1984 15.4583 23.0929 15.4583 23.6472 16.4157L27.0992 22.4756C27.6535 23.4331 27.2 24.2142 26.0913 24.2142H19.137C18.0409 24.2142 17.5874 23.4331 18.1291 22.4756L21.6441 16.4157ZM14.9669 4.7496C15.5213 3.79212 16.4031 3.79212 16.9575 4.7496L17.726 6.13543L19.5402 9.32283C19.9811 10.2299 19.9811 11.3008 19.5402 12.2079L13.4551 22.7528C12.9008 23.6094 11.9811 24.1512 10.9606 24.2142H5.90866C4.8 24.2142 4.34645 23.4457 4.90078 22.4756L14.9669 4.7496Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvax);
export default __webpack_public_path__ + "static/media/avax.5357480f79f7cb5f435b3e5b71f3f211.svg";
export { ForwardRef as ReactComponent };